import React, { useEffect, useState } from "react";
// import faqbg from "../assets/images/faqbg.jpg";
import faqbg from "../assets/images/frequently-asked-questions.png";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Getdata } from "../helpers/api.service";

// const faqs = [
//     {
//         question: "What is School Management Platform?",
//         answer:
//             "School Management is an all-in-one school management system designed to help schools streamline administrative tasks, improve communication, and enhance the learning experience.",
//     },
//     {
//         question: "Which types of schools can use this platform?",
//         answer:
//             "The platform can be used by primary, secondary, and international schools of various sizes.",
//     },
//     {
//         question: "How does School Management Platform improve school administration?",
//         answer:
//             "It simplifies student management, fee tracking, reporting, and communication between teachers, parents, and students.",
//     },
//     {
//         question: "Can parents track their child’s progress through the platform?",
//         answer:
//             "Yes, parents can access their child’s grades, attendance, and progress reports in real-time.",
//     },
//     {
//         question: "Is the platform accessible on mobile devices?",
//         answer: "Yes, the platform is fully mobile responsive and works on all devices.",
//     },
//         {
//         question: "How does School Management Platform improve school administration?",
//         answer:
//             "It simplifies student management, fee tracking, reporting, and communication between teachers, parents, and students.",
//     },
//     {
//         question: "Can parents track their child’s progress through the platform?",
//         answer:
//             "Yes, parents can access their child’s grades, attendance, and progress reports in real-time.",
//     },
//     {
//         question: "Is the platform accessible on mobile devices?",
//         answer: "Yes, the platform is fully mobile responsive and works on all devices.",
//     },
// ];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faq, setFaq] = useState([]);
  const fetchData = () => {
    // setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
        `/front/faq/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("FAQ API response:", res);
        if (res?.data) {
          setFaq(res.data.faqs);
        }
        // setImages(res.data.map((item) => item.image));
        // setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching FAQ:", err);
        // setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full text-left mb-14">
      {/* Background Section */}
      <div
        className="w-full"
        style={{
          backgroundImage: `url(${faqbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          aspectRatio: "1920/600",
        }}
      >
        <img
          src={faqbg}
          alt="FAQ Background"
          className="w-full h-auto block object-cover"
          style={{ display: "block", width: "100%", height: "auto" }}
        />
      </div>

      {/* White Card FAQ Section */}
      <div className="container flex items-start mx-auto px-6 md:px-12 lg:px-20 mt-4">
        {/* Heading Section */}
        <h2 className="text-2xl sm:text-3xl md:text-f40 text-left font-bold flex-1 pt-6">
          Frequently Asked <br />
          <span className="text-primary_main">Questions</span>
        </h2>

        {/* FAQ Card Section */}
        <div className="bg-white rounded-xl shadow-lg px-6 flex-1 lg:-mt-9 sm:-mt-9 -mt-9">
          <div className="divide-y">
            {faq.map((faq, index) => (
              <div key={index} className="py-4">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex justify-between items-center text-left text-base md:text-lg font-medium text-gray-800 hover:text-primary_main"
                >
                  {faq.question}
                  <span className="text-primary_main text-xl">
                    {openIndex === index ? (
                      <ChevronUp size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}
                  </span>
                </button>
                {openIndex === index && (
                  <div className="mt-2 text-gray-600 text-sm md:text-base">
                    {faq.description}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
